import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import styled from 'styled-components';

import * as shopActions from '../../actions/shopActions';

import { px, colors, roboto } from '../Common/style';

import Logo from './Logo';
import AccountDropdown from './AccountDropdown';
import Cart from '../Cart';

const Banner = styled.div`
  width: 100%;
  margin: 0;
  padding: ${px(16)};
  background-color: ${colors.safetyLemon};
  font-family: ${roboto};
  font-weight: 500;
  text-align: center;
  -webkit-box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.25);
  -moz-box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.25);
  box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.25);

  & a  {
    color: #000;
    text-decoration: underline;
  }
`;

const Header = (props) => (
  <>
    {/* <Banner>
      Weft Pro is here! <a href='/weft-pro'>Learn more</a> about our new subscription service
    </Banner> */}

    <header className={classnames({
      'header': true,
      'is-hidden-touch': true
    })}>
      <div className={'header-topright-container'}>
        <AccountDropdown />
        <Cart />
      </div>
      <Logo />
    </header>
  </>
);

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({...shopActions}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
